import React, { useState, useEffect } from 'react';
// import axios from 'axios'; // <-- 1. Ya no importamos axios directamente
import api from './apiService'; // <-- 2. Importamos nuestro 'api'
import 'bootstrap/dist/css/bootstrap.min.css'; 
import './Dashboard.css';
import TextBoxDisplay from './TextBoxDisplay';
import CashierBoxDisplay from './CashierBoxDisplay';
import CashierDetailBoxDisplay from './CashierDetailBoxDisplay';


function Dashboard({ session }) { // <-- 3. Destructuramos 'session' de las props
  const [cameraId, setCameraId] = useState(5);
  const [openCashiersStatus, setOpenCashiersStatus] = useState({ total_cashiers: 0, total_open_cashiers: 0, open_cashiers: [] });
  const [cashierStats, setCashierStats] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [outputData, setOutputData] = useState([]);

  // const apiPort = ...; // <-- 4. Eliminado. 'apiService' maneja esto.
  
  // Open Cashiers Status
  useEffect(() => {
    const fetchData = async () => {
      try {
        // 5. ¡Llamada a la API simplificada! Sin URL, sin headers.
        const response = await api.get('/api/open_cashiers');
        setOpenCashiersStatus(response.data);
        console.log("Open Cashiers Status: ", response.data);
      } catch (error) {
        console.error("Error fetching data for open cashiers:", error);
      }
    };

    fetchData();
    const intervalId = setInterval(fetchData, 1000);
    return () => clearInterval(intervalId);
    
  }, []); // <-- 6. Dependencias eliminadas. El interceptor se encarga de todo.


  // Cashiers Stats
  useEffect(() => {
    const fetchData = async () => {
      try {
        // 7. ¡Llamada a la API simplificada!
        const response = await api.get('/api/cashier_stats');
        setCashierStats(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    const intervalId = setInterval(fetchData, 1000);
    return () => clearInterval(intervalId);
    
  }, []); // <-- 8. Dependencias eliminadas.


  // Fetch the table data from the API
  useEffect(() => {
    const fetchData = async () => {
      try {
        // 9. ¡Llamada a la API simplificada!
        // Pasamos query params usando el objeto 'params'
        const response = await api.get('/api/data', {
          params: { camera_id: cameraId } 
        });
        setTableData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    const intervalId = setInterval(fetchData, 1000);
    return () => clearInterval(intervalId);
    
  }, [cameraId]); // <-- 10. Mantenemos 'cameraId' como dependencia

  // Output Table
  useEffect(() => {
    const fetchData = async () => {
      try {
        // 11. ¡Llamada a la API simplificada!
        const response = await api.get('/api/processed_data', {
          params: { camera_id: cameraId }
        });
        setOutputData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    const intervalId = setInterval(fetchData, 1000);
    return () => clearInterval(intervalId);
    
  }, [cameraId]); // <-- 12. Mantenemos 'cameraId' como dependencia

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-4">
        <TextBoxDisplay title="Cajas Abiertas" text1={openCashiersStatus.open_cashiers.toString()} text2={openCashiersStatus.total_open_cashiers.toString() + ' de ' + openCashiersStatus.total_cashiers.toString()} foregroundColor="#04105b" backgroundColor="#ffffff" />
        {cashierStats.map((row, index) => (
            <CashierBoxDisplay
              key={row.camera_id}
              cashierData={row}
              foregroundColor={cameraId === row.camera_id ? "#ffffff" : '#04105b'}
              backgroundColor={cameraId === row.camera_id ? "#04105b" : "#ffffff"}
              onClick={() => setCameraId(row.camera_id)}
            />
          ))}
        </div>

        <div className="col-md-8">
          <CashierDetailBoxDisplay
            key={cameraId}
            camera_id={cameraId}
            cashierReIdData={tableData}
            cashierOutputData={outputData}
            foregroundColor="#04105b"
            backgroundColor="#ffffff"
          />
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
